import React ,{useEffect}from 'react'
import logo from '../assets/logoOnboarding.png'
import{useNavigate } from 'react-router-dom'
import { useAuth } from '../Context/AuthProvider';
const Onboarding = () => {
    const navigate = useNavigate();
    const { auth } = useAuth()

  // useEffect(() => {
  //   const timeoutId = setTimeout(() => {
     
  //     navigate('/Signin');
    
  //   }, 3000);
  //   return () => {
  //       // Clean up the timeout if the component unmounts before the timeout is reached
  //       clearTimeout(timeoutId);
  //     };
  //   }, []);



  useEffect(() => {
    const timer = setTimeout(() => {
      // const token = localStorage.getItem("token");
      const token = auth;
      if (token) {
        navigate("/EnteryScreen");
      } else {
        navigate("/Signin");
      }
    }, 2500); // אנימציה של 2.5 שניות

    return () => clearTimeout(timer);
  }, [navigate]);


    return (
        <div className='w-full min-h-screen bg-PraimeryBlue flex flex-col justify-center items-center  '>
            <div className='mb-[186px]'>
                <p className='text-LightOrange text-lg'>מחקר כוויות ילדים
                </p>
                <p className='text-LightOrange text-lg font-bold'>

                    BGU</p>
                
            </div>
            <img className='w-[150px] animate-disaper' src={logo}/>

        </div>
    )
}

export default Onboarding